module.exports = __webpack_public_path__ + "img/img-3-10.0eb49890.png";